import React, { useRef, useEffect, useContext } from 'react';
import QuarterPageSlider from '../Components/Slider';
import Categories from '../Components/Category';
import Products from '../Components/Products/HomeProduct';
import { ThemeContext } from '../Context/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa'; // Import sun and moon icons

const Home = () => {
  const elementRef = useRef(null);
  const { theme, toggleTheme } = useContext(ThemeContext); // Access theme context

  useEffect(() => {
    const handleScroll = () => {
      if (elementRef.current) {
        const height = elementRef.current.offsetHeight;
        console.log('Element height:', height);
      }
    };

    const debouncedHandleScroll = debounce(handleScroll, 100); // Debounce by 100ms

    window.addEventListener('scroll', debouncedHandleScroll);
    return () => window.removeEventListener('scroll', debouncedHandleScroll);
  }, []);

  return (
    <div className={`home-page ${theme}`} style={{ marginTop: '10px' }}>
      {/* Theme Toggle Button with Icons
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <button
          className="btn btn-light" // Adjust styling as needed
          onClick={toggleTheme}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            fontSize: '16px',
            padding: '10px 20px',
          }}
        >
          {theme === 'light' ? <FaMoon size={20} /> : <FaSun size={20} />}
          Switch to {theme === 'light' ? 'Dark' : 'Light'} Theme
        </button>
      </div> */}

      {/* Quarter Page Slider */}
      <div ref={elementRef}>
        <QuarterPageSlider />
      </div>

      <div style={{ marginTop: '25px' }}></div>

      {/* Categories Section */}
      <h2 style={{ textAlign: 'center' }}>Categories</h2>
      <Categories />

      <div style={{ marginTop: '25px' }}></div>

      {/* Products Section */}
      <h2 style={{ textAlign: 'center' }}>Best to Buy</h2>
      <Products />
    </div>
  );
};

// Debounce function to limit the rate of execution
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export default Home;
